module.exports = __webpack_public_path__ + "static/media/rs.af6cd01b.svg";